import React from "react";
import { Bot, Sparkles } from "lucide-react";

const PalpitesShowBanner: React.FC<{ data: string }> = ({ data }) => {
  return (
    <div className="w-full bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black py-4 px-6 rounded-2xl shadow-2xl border-4 border-yellow-600 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <div className="flex items-center gap-3">
        <Bot className="w-10 h-10 md:w-12 md:h-12 shrink-0" />
        <div>
          <div className="text-2xl md:text-3xl font-black tracking-tight leading-none">
            I.A PALPITE GURU
          </div>
          <div className="text-xs md:text-sm font-semibold opacity-80">
            Inteligência Artificial do Jogo do Bicho
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center gap-2 bg-black/85 text-yellow-300 px-5 py-3 rounded-2xl font-black shadow-lg border-2 border-yellow-600/40">
        <Sparkles className="w-6 h-6 md:w-8 md:h-8" />
        <span className="text-2xl md:text-4xl lg:text-5xl tracking-tight leading-none">
          {data}
        </span>
      </div>
    </div>
  );
};

export default PalpitesShowBanner;
